import {
	Button, ButtonAppearance, ButtonColor, ButtonSize, CloseIcon, Dialog, EditIcon, TrashCanIcon,
} from '@aleph/shared-components';
import { useTranslation } from 'react-i18next';
import { RenderConfirmActionDialogProps } from 'wb-reddit/app/routes/hooks/useConfirmAction';

function SaveBeforeExitDialog({ onClose, onConfirm }: RenderConfirmActionDialogProps) {
	const { t } = useTranslation();

	return (
		<Dialog
			isOpen
			onClose={onClose}
			data-testid="save-before-exit-dialog"
		>
			<Dialog.Header
				preset={{
					prefix: <TrashCanIcon width={24}
						height={24}
					/>,
					title:  t('sc: discard changes?', 'Discard changes?'),
					suffix: <Button
						leftNode={
							<CloseIcon />
						}
						appearance={ButtonAppearance.GHOST}
						color={ButtonColor.GRAY}
						onClick={onClose}
						size={ButtonSize.LARGE}
					/>,
				}}
			/>
			<Dialog.Content className="!pb-4">
				{t('sc: unsaved changes warning', 'There are unsaved changes. Do you want to save them before exiting?')}
			</Dialog.Content>
			<Dialog.Footer>
				<Button
					title={t('sc: discard changes', 'Discard changes')}
					data-testid="overlay-discard"
					color={ButtonColor.RED}
					onClick={onConfirm}
					leftNode={<EditIcon />}
				/>
				<Button
					title={t('sc: continue editing', 'Continue editing')}
					leftNode={<TrashCanIcon />}
					onClick={onClose}
					data-testid="overlay-continue-editing"
				/>
			</Dialog.Footer>
		</Dialog>
	);
}

export default SaveBeforeExitDialog;
